import { readable } from 'svelte/store';

import defer from 'lodash/defer';

import { ROOT_SERVER_URL } from '../config';

// Note: We keep the deprecated destinations in the frontend for now to avoid breaking existing licenses with SFTP05 as destination.
const DEPRECATED_UPLOAD_DESTINATIONS = {
  sftp05: 'SFTP05 (deprecated)',
};

const ALL_UPLOAD_DESTINATIONS = {
  ...DEPRECATED_UPLOAD_DESTINATIONS,
  atf: 'AWS Transfer Family',
};

type AppConfig = {
  loading: boolean;
  data: {
    aws: { region: string };
    atf: { customerBucketNamePrefix: string };
    awsArbitratedPcapsInventoryS3BucketName: string;
    mstMaceAuthCookie: string;
    jenkinsUrl: string;
    versionInfo: {
      version: string | undefined;
      branch: string | undefined;
      pipeline: string | undefined;
    };
    flags: { atfEnabled: boolean; atfHttpsEnabled: boolean };
  };
  error?: unknown;
};

export const appConfig = readable<AppConfig>({ loading: true } as AppConfig, function start(set) {
  try {
    defer(async () => {
      const config = await fetch(`${ROOT_SERVER_URL}/open-api/config`).then((response) => response.json());
      set({
        data: {
          ...config,
          supportedUploadDestinations: config.flags.atfEnabled ? ALL_UPLOAD_DESTINATIONS : DEPRECATED_UPLOAD_DESTINATIONS,
        },
        loading: false,
      });
    });
  } catch (error) {
    console.error('[appConfig] Failed to retrieve app configuration from server!', error);
    set({ loading: false, error } as AppConfig);
  }
});
